import { FirebaseError } from "firebase/app";
import { isErrorWithCode } from "./auth";

const userDoesNotExistErrorPattern = /User with email (\S+) does not exist/;

export function getSignInErrorDetails(error: unknown): string {
  if (!error) {
    return "nd.";
  }
  if (error instanceof FirebaseError && userDoesNotExistErrorPattern.test(error.message)) {
    const match = error.message.match(userDoesNotExistErrorPattern);
    const email = match?.[1];
    return `Email ${email} nie jest przypisany do konta klienta, w celu weryfikacji lub założenia nowego konta skontaktuj się z nami: biuro@przezmorze.pl`;
  }
  if (isErrorWithCode(error) && error.code === "auth/email-already-in-use") {
    return "Niepoprawne hasło";
  }
  if (typeof error === "object" && "message" in error && typeof error.message === "string") {
    return error.message;
  }
  return JSON.stringify(error);
}
